import { ChangeEventHandler } from 'react';
import './TextArea.scss';

export enum TextareaResizable {
    Default = '',
    Vertical = 'msds-text-area__text-input--resize-y',
    Horizontal = 'msds-text-area__text-input--resize-x',
    Standard = 'msds-text-area__text-input--resize',
}

export function TextArea(props: TextAreaProps) {
    const {
        label,
        value,
        onChange,
        readonly,
        disabled,
        maxLength,
        helperText,
        resizable,        
        error,
        ...otherProps
    } = props;
    
    const textAreaClassName = 'msds-text-area__text-input'                                                     
                              + (resizable? ' ' + resizable : '')
                              + (error? ' msds-text-area__text-input--error' : '');
    return (
        <div className="msds-text-area">
            <div className="msds-input__icon-wrapper">
                <textarea                    
                    className={textAreaClassName}
                    placeholder="Enter your description"
                    maxLength={maxLength}
                    readOnly={readonly}
                    disabled={disabled}
                    id={label?.split(' ').join('-')}
                    onChange={onChange}
                    {...otherProps}                    
                />
                {label && (
                    <label
                        className="msds-text-area__label"
                        htmlFor={label?.split(' ').join('-')}
                    >
                        {label}
                    </label>
                )}
                {helperText && (
                    <p className="msds-text-area__message">
                        <span>{helperText}</span>
                    </p>
                )}
                {error && (
                    <p className="msds-text-area__message">
                        <span>{error}</span>
                    </p>
                )}
            </div>
        </div>
    );
}

type TextAreaProps = {
    label?: string;
    helperText?: string;
    value?: string;
    onChange?: ChangeEventHandler<HTMLTextAreaElement>;
    disabled?: boolean;
    readonly?: boolean;
    maxLength?: number;
    resizable?: TextareaResizable;    
    error?: string | string[];
    [otherProps: string]: unknown;
};
